import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "./ui/dialog";
import { toast } from "sonner";
import { Phone } from "lucide-react";
import { submitCallback } from "../lib/api";

const CallbackDialog = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [agree, setAgree] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !phone) {
      toast.error("Please fill in all fields");
      return;
    }
    if (!agree) {
      toast.error("Please agree to processing of personal data");
      return;
    }
    try {
      setLoading(true);
      await submitCallback({ name, phone });
      toast.success("Thank you! We will call you back within 10 minutes.");
      setName("");
      setPhone("");
      setOpen(false);
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again or call us directly.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[460px] bg-white border-t-4 border-t-[#e30613] rounded-sm">
        <DialogHeader>
          <div className="inline-flex items-center gap-2 text-[12px] uppercase text-[#e30613] font-medium">
            <Phone size={14} /> Quick request
          </div>
          <DialogTitle className="text-[24px] font-bold text-[#2c2c2c] leading-tight">
            Request a callback
          </DialogTitle>
          <DialogDescription className="text-sm text-[#7a7a7a]">
            We will call you back within 10 minutes to discuss your enquiry.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-5 mt-2">
          <div>
            <label className="text-xs uppercase tracking-[0.06em] text-[#7a7a7a] font-medium">Your name *</label>
            <input className="pt-input-light" value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.06em] text-[#7a7a7a] font-medium">Phone *</label>
            <input className="pt-input-light" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+971 ..." />
          </div>
          <label className="flex items-start gap-2 text-xs text-[#7a7a7a]">
            <input type="checkbox" className="mt-0.5" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
            <span>I agree to processing of personal data</span>
          </label>
          <button type="submit" disabled={loading} className="btn-red w-full justify-center disabled:opacity-60">
            {loading ? "Sending..." : "Send request"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CallbackDialog;
